import { CAREERS_JOBS_LIST, CAREERS_JOB_DETAIL, CAREERS_APPLY } from "@/constants/urls";
import apiClient, { get } from "@/helpers/api.helper";
import { JobPost, JobApplicationPayload } from "@/models/api/careers";

/**
 * Fetches all publicly active job openings.
 */
export const getActiveJobs = async (): Promise<JobPost[]> => {
  const res = await get<{ count: number; data: JobPost[] }>(CAREERS_JOBS_LIST);
  return res?.data ?? [];
};

/** Fetches a single active job posting by id. */
export const getJobById = (id: string): Promise<JobPost> => {
  return get<JobPost>(CAREERS_JOB_DETAIL(id));
};

/** Submits a public job application (multipart/form-data, including resume/cover letter files). */
export const submitJobApplication = (payload: JobApplicationPayload): Promise<any> => {
  const fd = new FormData();
  fd.append("JobPostId", payload.jobPostId);
  fd.append("FirstName", payload.firstName);
  fd.append("LastName", payload.lastName);
  fd.append("Email", payload.email);

  if (payload.phone) fd.append("Phone", payload.phone);
  if (payload.gender) fd.append("Gender", payload.gender);
  if (payload.dateOfBirth) fd.append("DateOfBirth", payload.dateOfBirth);
  if (payload.education) fd.append("Education", payload.education);
  if (payload.experience) fd.append("Experience", payload.experience);
  if (payload.skills) fd.append("Skills", payload.skills);
  if (payload.expectedSalary) fd.append("ExpectedSalary", payload.expectedSalary);
  if (payload.noticePeriod) fd.append("NoticePeriod", payload.noticePeriod);
  if (payload.address) fd.append("Address", payload.address);
  if (payload.linkedInProfile) fd.append("LinkedInProfile", payload.linkedInProfile);
  if (payload.portfolio) fd.append("Portfolio", payload.portfolio);
  if (payload.whyHireYou) fd.append("WhyHireYou", payload.whyHireYou);
  if (payload.resume) fd.append("Resume", payload.resume);
  if (payload.coverLetter) fd.append("CoverLetter", payload.coverLetter);

  return apiClient.uploadFormData(CAREERS_APPLY, fd);
};
